import { makeStyles } from '@material-ui/core/styles'

import { COLORS, FONT_FAMILY, FONT_WEIGHT } from 'styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.medium,
    fontSize: 14,
    color: COLORS.FONT,
    marginBottom: 8,
  },
  labelError: {
    color: theme.palette.error.main,
  },
  hint: {
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.regular,
    fontSize: 12,
    color: COLORS.FONT_SECONDARY,
    marginBottom: 8,
  },
  card: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    boxSizing: 'border-box',
    backgroundColor: COLORS.WHITE,
    border: `1px dashed ${COLORS.BASE}`,
    borderRadius: 8,
    padding: 16,
    textAlign: 'center',
    height: 220,
    overflow: 'hidden',
  },
  cardSquare: {
    width: 180,
  },
  cardWide: {
    width: 280,
  },
  contentArea: {
    flex: 1,
    width: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  preview: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    borderRadius: 4,
  },
  emptyIcon: {
    color: COLORS.BASE,
    marginBottom: 8,
    flexShrink: 0,
  },
  emptyText: {
    fontFamily: FONT_FAMILY,
    fontSize: 13,
    color: COLORS.FONT_SECONDARY,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '100%',
    height: 36,
    marginTop: 12,
  },
  deleteButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    padding: 6,
    backgroundColor: COLORS.WHITE,
    color: COLORS.FONT,
    zIndex: 1,
    '&:hover': {
      backgroundColor: COLORS.LIGHT_GREY,
    },
  },
}))

export { useStyles }
